import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  InputAdornment,
  Link,
  Alert,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import { hubApi } from "../services/hubApi";

const fieldSx = {
  mb: 2,
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    bgcolor: "#1E293B",
    "& fieldset": { borderColor: "rgba(255,255,255,0.08)" },
    "&:hover fieldset": { borderColor: "rgba(255,107,0,0.3)" },
    "&.Mui-focused fieldset": { borderColor: "#FF6B00" },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "#FF6B00" },
};

const btnSx = {
  py: 1.3,
  fontSize: "0.95rem",
  bgcolor: "#FF6B00",
  borderRadius: "10px",
  "&:hover": { bgcolor: "#E06000" },
  "&.Mui-disabled": { bgcolor: "#333", color: "#666" },
};

export default function AuthScreen({ onLogin }) {
  const [mode, setMode] = useState("login"); // login | forgot
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setLoading(true);
    await onLogin(email.trim(), password);
    setLoading(false);
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await hubApi.forgotPassword(email.trim());
      setInfo(data?.message || "Se o e-mail estiver cadastrado, enviamos as instruções de redefinição.");
    } catch {
      // Resposta é sempre 200 no backend; se cair aqui é rede.
      setInfo("Se o e-mail estiver cadastrado, enviamos as instruções de redefinição.");
    }
    setLoading(false);
  };

  const irParaForgot = () => { setMode("forgot"); setInfo(""); };
  const voltarLogin = () => { setMode("login"); setInfo(""); };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0B0F19", p: 2 }}>
      <Card sx={{ maxWidth: 420, width: "100%", bgcolor: "#111827", border: "1px solid rgba(255, 255, 255, 0.06)", borderRadius: "16px" }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Box component="img" src="/gateway-icon.png" alt="OtimizApp HUB" sx={{ width: 72, height: 72, borderRadius: "16px", mb: 1, objectFit: "cover" }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: "#F3F4F6" }}>OtimizAPP HUB</Typography>
            <Typography variant="body2" sx={{ color: "#6B7280", mt: 0.5 }}>
              {mode === "forgot" ? "Recuperar acesso" : "Hub de Conexoes Multi-Canal & VoIP"}
            </Typography>
          </Box>

          {info && <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>{info}</Alert>}

          {mode === "login" ? (
            <form onSubmit={handleSubmit} autoComplete="on">
              <TextField
                fullWidth label="Email" type="email" placeholder="seu@email.com"
                value={email} onChange={(e) => setEmail(e.target.value)} variant="outlined" autoComplete="username"
                InputProps={{ startAdornment: (<InputAdornment position="start"><EmailIcon sx={{ color: "#6B7280", fontSize: 20 }} /></InputAdornment>) }}
                sx={fieldSx}
              />
              <TextField
                fullWidth label="Senha" type="password" placeholder="••••••••"
                value={password} onChange={(e) => setPassword(e.target.value)} variant="outlined" autoComplete="current-password"
                InputProps={{ startAdornment: (<InputAdornment position="start"><LockIcon sx={{ color: "#6B7280", fontSize: 20 }} /></InputAdornment>) }}
                sx={{ ...fieldSx, mb: 1.5 }}
              />
              <Box sx={{ textAlign: "right", mb: 2 }}>
                <Link component="button" type="button" onClick={irParaForgot} underline="hover" sx={{ color: "#9CA3AF", fontSize: 13, "&:hover": { color: "#FF6B00" } }}>
                  Esqueci minha senha
                </Link>
              </Box>
              <Button type="submit" fullWidth variant="contained" size="large" disabled={loading || !email.trim() || !password} sx={btnSx}>
                {loading ? "Autenticando..." : "Entrar"}
              </Button>
            </form>
          ) : (
            <form onSubmit={handleForgot} autoComplete="on">
              <Typography variant="body2" sx={{ color: "#9CA3AF", mb: 2 }}>
                Digite seu e-mail que enviaremos um link para você definir uma nova senha.
              </Typography>
              <TextField
                fullWidth label="Email" type="email" placeholder="seu@email.com"
                value={email} onChange={(e) => setEmail(e.target.value)} variant="outlined" autoComplete="username"
                InputProps={{ startAdornment: (<InputAdornment position="start"><EmailIcon sx={{ color: "#6B7280", fontSize: 20 }} /></InputAdornment>) }}
                sx={{ ...fieldSx, mb: 3 }}
              />
              <Button type="submit" fullWidth variant="contained" size="large" disabled={loading || !email.trim()} sx={btnSx}>
                {loading ? "Enviando..." : "Enviar link de redefinição"}
              </Button>
              <Box sx={{ textAlign: "center", mt: 2 }}>
                <Link component="button" type="button" onClick={voltarLogin} underline="hover" sx={{ color: "#9CA3AF", fontSize: 13, "&:hover": { color: "#FF6B00" } }}>
                  Voltar ao login
                </Link>
              </Box>
            </form>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
